export default __webpack_public_path__ + "static/img/qr-code@2x.6d35b1.png";